import Vue from 'vue'
import Router from 'vue-router'
import HomeRouter from './home'
import ProductRouter from './product'
import UserRouter from './user'
import GroupList from './group'
import main from '../main'
Vue.use(Router);
let route = [];
route = route.concat(HomeRouter, ProductRouter, UserRouter, GroupList);
const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: route,
  scrollBehavior (to, from, savedPosition) {
    return {x:0, y:0}
  }
});

router.beforeEach((to, from, next) => {
  // 验证是否登陆
  const isLogin = localStorage.getItem('token');
  // 需要登陆的路由
  const routerArr = ['/personal-set', '/car', '/account-set', '/order-list'];
  if (!isLogin && to.path !== '/login' && routerArr.indexOf(to.path) > -1) {
    main.$dialog.confirm({
      title: '登陆提醒',
      message: '当前操作需要登陆，是否前往登陆？'
    }).then(() => {
      next({
        path: '/login',
        query: {redirect: to.fullPath}
      })
    }).catch(() => {

    });

  } else {
    next()
  }
})
export default router

